var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", [
    _c("h2", { staticClass: "page-title" }, [_vm._v("Admin")]),
    _vm._v(" "),
    _c("nav", [
      _c(
        "ul",
        { staticClass: "admin-page-links" },
        _vm._l(_vm.getPermalinks, function(permalink, name) {
          return _c(
            "li",
            { staticClass: "animate__animated animate__fadeIn" },
            [
              _c("a", { attrs: { href: permalink } }, [
                _vm._v(
                  "\n                Manage " +
                    _vm._s(name) +
                    "\n                "
                )
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fd8a062", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fd8a062","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 666/
// module chunks = 1